<div class="MainDiv">
	<div>
		<caass-manual-selector-extended-info [AudienceMode]="AudienceMode" [SelectedPerson]="SelectedPerson" [FacilityID]="FacilityID">
		</caass-manual-selector-extended-info>
	</div>

	<div class="TopMargin sm-SelectMenu">
		<label>Day:</label>
		<select class="form-control" name="DayOption" (ngModelChange)="onDayChange($event)" [(ngModel)]="DayOption">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDayOptions" [ngValue]="o.DayID">
				{{ o.DayDesc }}
			</option>
		</select>
	</div>

	<!--Schedule Info-->
	<div class="TopMargin">
		<!-- <div>
            <label>Schedule Day:</label>
            <select></select>
        </div> -->

		<p-table
			#mydt
			[value]="lstSchedule"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[paginator]="true"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedEntry"
			dataKey="Barcode"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 20]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Column Names-->
				<tr style="height: 4rem">
					<th pSortableColumn="CourseDesc">Course<p-sortIcon field="CourseDesc"></p-sortIcon></th>
					<th pSortableColumn="RoomNo">Room<p-sortIcon field="RoomNo"></p-sortIcon></th>
					<th pSortableColumn="Instructor">Instructor<p-sortIcon field="Instructor"></p-sortIcon></th>
					<th pSortableColumn="Section">Section<p-sortIcon field="Section"></p-sortIcon></th>
					<th pSortableColumn="Period">Period<p-sortIcon field="Period"></p-sortIcon></th>
					<th pSortableColumn="Day">Day<p-sortIcon field="Day"></p-sortIcon></th>
					<th pSortableColumn="Semester">Semester<p-sortIcon field="Semester"></p-sortIcon></th>
					<th pSortableColumn="StartTime">Start Time<p-sortIcon field="StartTime"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-entry>
				<tr [pSelectableRow]="entry">
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ entry[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
